<script setup lang="ts">
import { RouterLink, useRoute } from 'vue-router'
import { PhCheckCircle, PhCircle } from '@phosphor-icons/vue'
import { Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent } from '@/components/ui/sidebar'
import { learnCurriculum } from '@/data/learn/curriculum'
import { useLearnProgress } from '@/composables/useLearnProgress'

const route = useRoute()
const { completedIds } = useLearnProgress()
</script>

<template>
  <Sidebar collapsible="icon" side="left">
    <SidebarContent class="flex-1 overflow-y-auto min-h-0 pt-14">
      <SidebarGroup>
        <SidebarGroupContent class="group-data-[collapsible=icon]:hidden">
          <div v-for="mod in learnCurriculum" :key="mod.id" class="px-3 py-2">
            <p class="mb-1.5 px-1 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
              {{ mod.title }}
            </p>
            <RouterLink
              v-for="lesson in mod.lessons"
              :key="lesson.id"
              :to="`/learn/lesson/${lesson.id}`"
              class="flex items-center gap-2 rounded-lg px-2 py-1.5 text-sm transition"
              :class="
                route.params.lessonId === lesson.id
                  ? 'bg-primary/15 text-foreground font-medium'
                  : 'text-foreground/75 hover:bg-muted hover:text-foreground'
              "
            >
              <PhCheckCircle
                v-if="completedIds.has(lesson.id)"
                :size="15"
                weight="fill"
                class="shrink-0 text-primary"
              />
              <PhCircle v-else :size="15" class="shrink-0 text-muted-foreground/40" />
              <span class="truncate">{{ lesson.title }}</span>
            </RouterLink>
          </div>
        </SidebarGroupContent>
      </SidebarGroup>
    </SidebarContent>
  </Sidebar>
</template>
